import React from 'react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { ApiConfig } from './types/apiConfig';
import { store } from './redux/store';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { initAuth } from './plugins/auth-sdk';
import { ROUTES } from './router/types';
import { initTagManager } from './utils/tagManager';

import { syncLanguageFromUrl } from './i18n/config';

import './index.scss';

fetch('config.json')
  .then((response) => response.json())
  .then((apiConfig: ApiConfig) =>
    initAuth({
      clientId: apiConfig.fusionAuth.clientId,
      domain: apiConfig.fusionAuth.domain,
      redirectUri: window.location.origin + ROUTES.COMPLETE_REGISTRATION,
    }).then(() => apiConfig)
  )
  .then((apiConfig) => initTagManager(apiConfig.brandGroupUrl))
  .catch((error) => {
    console.error('Missing necessary API configuration data:', error);
  })
  .finally(() => {
    syncLanguageFromUrl(); // initAuth has restored the original URL by now.

    // Always render React app
    const container = document.getElementById('root');
    const root = createRoot(container!);
    root.render(
      <React.StrictMode>
        <I18nextProvider i18n={i18next}>
          <ReduxProvider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ReduxProvider>
        </I18nextProvider>
      </React.StrictMode>
    );
  });
